/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum ItemsAlignmentType {
  JustifyCenter = "JUSTIFY_CENTER",
  FitToContent = "FIT_TO_CONTENT",
}
